/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postExternalTeamCalendar = (params) =>
  makeApiCall(`/external-team/calendar`, 'POST', params);

export const postExternalTeamProgress = (params) =>
  makeApiCall(`/external-team/progress`, 'POST', params);

export const postExternalTeamList = (params) => makeApiCall(`/external-team/list`, 'POST', params);
